import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/gopath/src/github.com/rumblefrog/source-chat-relay/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "troubleshooting"
    }}>{`Troubleshooting`}</h1>
    <p>{`Common problems & steps to troubleshoot`}</p>
    <h2 {...{
      "id": "game-server-is-not-connecting-to-the-relay-server-no-entity"
    }}>{`Game server is not connecting to the relay server? (No Entity)`}</h2>
    <p>{`This can be numerous amount of things, check the Sourcemod error log for errors emitted by the plugin`}</p>
    <h2 {...{
      "id": "im-getting-errno-3-from-the-plugin"
    }}>{`I'm getting errno 3 from the plugin`}</h2>
    <p>{`Ensure that the relay server is running and the Discord bot is online`}</p>
    <p>{`If else, ensure that you have corrected port forwarded if necessary and that your firewall rules has been configured to allow the traffic`}</p>
    <p>{`A good way to test remote connectivity is using netcat utility available on Linux`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      